import { EnumerationBuilder } from 'utility-js-enumeration';
// FIXME: Remove this
/**
 * @deprecated use TermStatusStrategy
 */

const PICK_TIMES = 'Pick Times';
const REG_OPEN = 'Registration Open';
const PRIO_REG = 'Priority Registration';
const IN_PROG = 'In Progress';

export const TermStatusEnum = EnumerationBuilder.useDefinitionAsEnum('TermStatusEnum', {
  DEFAULT: {},
  BEFORE_REG_OPEN: {
    status_title: 'Registration begins {{registration_start_date}}',
    status_title_plain: 'Registration begins <%= registration_start_date %>',
    popover_title: 'Registration',
    popover_content:
      '<strong class="text-bold">{{registration_time_until}} until registration is open</strong><p class="text maz">Registration begins {{registration_start_date_year}}</p>',
    status_function(reg_s: moment.Moment, reg_e: moment.Moment, term_s: moment.Moment, term_e: moment.Moment) {
      return moment().isBefore(reg_s);
    },
    button_title: 'Times not available yet',
    button_label: PICK_TIMES
  },
  REG_OPEN: {
    status_title: REG_OPEN,
    status_title_plain: REG_OPEN,
    popover_title: 'Registration',
    popover_content:
      '<strong class="text-bold">Registration open</strong><p class="text maz">Registration begins {{registration_start_date_year}}</p>',
    status_function(reg_s: moment.Moment, reg_e: moment.Moment, term_s: moment.Moment, term_e: moment.Moment) {
      return reg_s.isBefore(moment()) && reg_e.isAfter(moment());
    },
    button_title: REG_OPEN,
    button_label: 'Ready to Register'
  },
  PRIORITY_BEFORE_REG_OPEN: {
    status_title: '<i class="icon eab-icon-rocket mrs" aria-hidden="true"></i>Priority Registration',
    status_title_plain: PRIO_REG,
    popover_title: PRIO_REG,
    popover_content:
      '<strong class="text-bold">You get to register before other students!</strong><p class="text maz">Registration begins {{registration_start_date_year}}</p>',
    status_function: (PRreg_s: moment.Moment, PRreg_e: moment.Moment) => PRreg_s.isAfter(moment()),
    button_title: 'Times available - Build your schedule',
    button_label: PICK_TIMES
  },
  PRIORITY_REG_OPEN: {
    status_title: '<i class="icon eab-icon-rocket mrs" aria-hidden="true"></i>Priority Registration Open',
    status_title_plain: 'Priority Registration Open',
    popover_title: PRIO_REG,
    popover_content:
      '<strong class="text-bold">Priority registration open!</strong><p class="text maz">Registration begins {{registration_start_date_year}}</p>',
    status_function: (PRreg_s: moment.Moment, PRreg_e: moment.Moment) =>
      PRreg_s.isBefore(moment()) && PRreg_e.isAfter(moment()),
    button_title: REG_OPEN,
    button_label: 'Ready to Register'
  },
  BEFORE_TERM_START: {
    status_title: 'Term begins {{term_start_date}}',
    status_title_plain: 'Term begins <%= term_start_date %>',
    popover_title: 'Term begins soon',
    popover_content:
      '<strong class="text-bold">{{term_time_until}} until your term starts</strong><p class="text maz">{{term_start_date_year}} - {{term_end_date_year}}</p>',
    status_function(reg_s: moment.Moment, reg_e: moment.Moment, term_s: moment.Moment, term_e: moment.Moment) {
      return reg_e.isBefore(moment()) && term_s.isAfter(moment());
    },
    button_title: 'View or edit your schedule',
    button_label: 'View / Edit Schedule'
  },
  TERM_IN_PROGRESS: {
    status_title: IN_PROG,
    status_title_plain: IN_PROG,
    popover_title: IN_PROG,
    popover_content:
      '<strong class="text-bold">{{term_time_left}} left in this term</strong><p class="text maz">{{term_start_date_year}} - {{term_end_date_year}}</p>',
    status_function(reg_s: moment.Moment, reg_e: moment.Moment, term_s: moment.Moment, term_e: moment.Moment) {
      return term_s.isBefore(moment()) && term_e.isAfter(moment());
    },
    button_title: 'View or edit your schedule',
    button_label: 'View / Edit Schedule'
  },
  TERM_COMPLETED: {
    status_title: 'Completed',
    status_title_plain: 'Completed',
    popover_title: 'Completed',
    popover_content: '<p class="text maz">{{term_start_date_year}} - {{term_end_date_year}}</p>',
    status_function(reg_s: moment.Moment, reg_e: moment.Moment, term_s: moment.Moment, term_e: moment.Moment) {
      return term_e.isBefore(moment());
    }
  }
});

angular.module('capability-ng-academic-planner').constant('TermStatusEnum', TermStatusEnum);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/types/term_status_enum.ts